import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

function CancelButton({ children, size, disabled, color, variant, ...rest }) {
  return (
    <Button
      size={size}
      sx={{
        textTransform: 'none',
        '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
      }}
      {...rest}
      color={color}
      variant={variant}
      disabled={disabled}
    >
      {children ?? 'Cancel'}
    </Button>
  );
}

export default CancelButton;

CancelButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  color: PropTypes.oneOf([
    'inherit',
    'primary',
    'secondary',
    'success',
    'error',
    'info',
    'warning',
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
};

CancelButton.defaultProps = {
  size: 'medium',
  color: 'error',
  variant: 'text',
};
